import FooterContext, { FooterContextType } from "./FooterContext";
import { useContext } from "react";

export const useFooter = (): FooterContextType => {
    const context = useContext(FooterContext);
    if (!context) {
        throw new Error("useFooter error");
    }
    return context;
};